import { SlugPath } from 'types/slugPath'
import { Category } from '@/network/graphql.g'
import { ID } from 'graphql-ws'

export interface Item {
  id: ID
  title: string
  isSelected: boolean
  subItems?: Item[]
  url?: string
  desktopBadge?: string
  mobileBadge?: string
  highlight: boolean
}

export enum ItemType {
  subcategoryItem,
  subItem,
  specialSubItem
}

export const makeItems = (
  items: Category[],
  type: ItemType,
  slugPath: SlugPath,
  omitSelectionForIds?: ID[]
): Item[] => {
  return items.map((item): Item => {
    switch (type) {
      case ItemType.specialSubItem:
        return {
          ...item,
          title: item.title,
          id: item.id,
          mobileBadge: item.mobileBadge,
          desktopBadge: item.desktopBadge,
          highlight: item.isHighlight,
          isSelected:
            !omitSelectionForIds?.includes(item.id) &&
            item.id === slugPath.specialSubItemId?.id
        }
      case ItemType.subItem:
        // eslint-disable-next-line no-case-declarations
        const isSubItemActive = slugPath.subItemId?.id === item.id
        return {
          ...item,
          title: item.title,
          id: item.id,
          mobileBadge: item.mobileBadge,
          desktopBadge: item.desktopBadge,
          highlight: item.isHighlight,
          isSelected:
            !omitSelectionForIds?.includes(item.id) &&
            isSubItemActive &&
            slugPath.specialSubItemId === null,
          subItems:
            isSubItemActive && item.children
              ? makeItems(item.children, ItemType.specialSubItem, slugPath)
              : null
        }
      case ItemType.subcategoryItem:
        // eslint-disable-next-line no-case-declarations
        const isSubcategoryItemActive = slugPath.itemId?.id === item.id
        return {
          ...item,
          title: item.title,
          id: item.id,
          mobileBadge: item.mobileBadge,
          desktopBadge: item.desktopBadge,
          highlight: item.isHighlight,
          isSelected:
            !omitSelectionForIds?.includes(item.id) &&
            isSubcategoryItemActive &&
            slugPath.subItemId === null,
          subItems:
            isSubcategoryItemActive && item.children
              ? makeItems(item.children, ItemType.subItem, slugPath)
              : null
        }
    }
  })
}
